import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import ProductList from './ProductList';

const productCatogories = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const editRef = useRef(null);
  const [productData, setProductData] = useState([
    {
      name: '',
      updated: false,
      editMode: false,
    },
  ]);

  const handleChange = (e) => {
    setProductData({
      ...productData,
      [e.target.name]: e.target.value,
    });
  };

  const cancelEdit = () => {
    setProductData({
      name: '',
      updated: shiftData.updated,
      editMode: false,
    });
  };

  const handleEditMode = (product) => {
    setProductData({
      uuid: product.uuid,
      name: product.name,
      updated: productData.updated,
      editMode: true,
    });
    if (editRef.current) {
      window.scrollTo({
        behavior: 'smooth',
        top: editRef.current.offsetTop - 150,
      });
    }
  };

  const confirmSubmit = (e) => {
    const { name } = productData;
    confirmAlert({
      title: 'Are you sure you want to',
      message: productData.editMode ? `update ${name}` : 'add a new product',
      buttons: [
        {
          label: 'Yes',
          onClick: () => submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const headers = authHeader(1);
    const url = `${process.env.API_URL}/lubes/bunk/category/`;
    let method = 'POST';
    let formData = productData;
    if (productData.editMode) {
      method = 'PUT';
      formData.name = productData.name;
    }
    axios({
      method,
      url,
      data: formData,
      headers,
    })
      .then(() => {
        toast.success('Products catogories added successfully');
        window.scrollTo({
          behavior: 'smooth',
          top: editRef.current.offsetTop - 150,
        });
        setIsSubmitting(false);
        setProductData({
          name: '',
          updated: !productData.updated,
          editMode: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table" ref={editRef}>
        <header>
          <h3> product Catogories</h3>
        </header>
        <main>
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th> Product Catogory </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${productData.editMode ? 'highlight-bg' : ''}`}>
                  <td>
                    <div className="input-wrapper">
                      <input
                        name="name"
                        type="text"
                        onChange={handleChange}
                        placeholder="Product Catogories"
                        value={productData.name}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="form-actions">
              <button className="submit" type="submit" onClick={confirmSubmit}>
                Submit
              </button>
              {productData.editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        </main>
      </section>
      <ProductList key={productData.updated} onEdit={handleEditMode} />
    </>
  );
};

export { productCatogories };
